import React from 'react';
import { Modal, Spinner } from 'react-bootstrap';

const formatarDataPosicao = (value) => {
  if (!value) return '-';
  const rawValue = String(value);
  const isoMatch = rawValue.match(/^(\d{4})-(\d{2})-(\d{2})[T\s](\d{2}):(\d{2})(?::(\d{2}))?/);
  const date = isoMatch
    ? new Date(Date.UTC(
      Number(isoMatch[1]),
      Number(isoMatch[2]) - 1,
      Number(isoMatch[3]),
      Number(isoMatch[4]),
      Number(isoMatch[5]),
      Number(isoMatch[6] || 0)
    ))
    : new Date(rawValue);

  if (Number.isNaN(date.getTime())) return String(value);

  return date.toLocaleString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const getFonteLabel = (integracao) => {
  if (!integracao) return '';
  if (typeof integracao === 'string') return integracao;

  return integracao.provider
    || integracao.Provider
    || integracao.nome
    || integracao.Nome
    || integracao.tecnologia
    || integracao.Tecnologia
    || '';
};

const DescargaLocalizacaoModal = ({
  show,
  onClose,
  row,
  loading,
  error,
  posicao
}) => (
  <Modal show={show} onHide={onClose} animation={false} centered>
    <Modal.Header closeButton>
      <Modal.Title>Localizacao do cavalo</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="mb-3 small text-muted d-flex flex-wrap gap-3">
        <span><strong>Carga:</strong> {row?.numeroCarga || '-'}</span>
        <span><strong>Placa:</strong> {row?.placaVeiculo || '-'}</span>
        <span><strong>Frota:</strong> {row?.numeroFrota || '-'}</span>
      </div>

      {loading ? (
        <div className="d-flex align-items-center gap-2 text-muted py-4">
          <Spinner animation="border" size="sm" />
          <span>Buscando localizacao no provedor externo...</span>
        </div>
      ) : null}

      {!loading && error ? (
        <div className="alert alert-warning mb-0">{error}</div>
      ) : null}

      {!loading && posicao ? (
        <>
          <div className="mb-3 small text-muted d-flex flex-wrap gap-3">
            {posicao.cidade ? (
              <span>
                <strong>Local:</strong> {`${posicao.cidade}${posicao.estado ? `/${posicao.estado}` : ''}`}
              </span>
            ) : null}
            {posicao.logradouro ? (
              <span><strong>Endereco:</strong> {posicao.logradouro}</span>
            ) : null}
            {posicao.dataPosicao ? (
              <span><strong>Atualizacao:</strong> {formatarDataPosicao(posicao.dataPosicao)}</span>
            ) : null}
            {getFonteLabel(posicao.integracao) ? (
              <span><strong>Fonte:</strong> {getFonteLabel(posicao.integracao)}</span>
            ) : null}
          </div>

          <div className="rounded overflow-hidden shadow-sm w-100" style={{ border: '1px solid #e5e7eb' }}>
            <iframe
              title="google-maps-descarga-localizacao"
              src={`https://www.google.com/maps?q=${encodeURIComponent(`${posicao.latitude},${posicao.longitude}`)}&z=16&output=embed`}
              width="100%"
              height="320"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </>
      ) : null}
    </Modal.Body>
  </Modal>
);

export default DescargaLocalizacaoModal;
